import Organization from ".";
import OrganizerDetails from "./OrganizerDetails";
import BasicSettings from "./BasicSettings";
import OrganizationOverview from "./OrganizationOverview";

export const organizationUserRoutes = (data) => {
  const user_role_in_org = data?.selectedOrganization?.verificationData?.role; //promoter||"admin"||"staff"

  const global_routes = [
    {
      path: "/:lang/user/organization/overview",
      title: "Organization Overview",
      layout: "user",
      routeType: "organization",
      component: OrganizationOverview,
    },
  ];

  if (user_role_in_org === "promoter") {
    return global_routes;
  }

  return [
    ...global_routes,
    {
      path: "/:lang/user/organization",
      title: "Organization",
      layout: "user",
      routeType: "organization",
      component: Organization,
    },
    {
      path: "/:lang/user/organization/settings/:orgId",
      title: "Basic Settings",
      layout: "user",
      routeType: "organization",
      component: BasicSettings,
    },
    {
      path: "/:lang/organization/details/:orgId",
      title: "Organizer Detail",
      layout: "front",
      component: OrganizerDetails,
    },
  ];
};
